import ApiService from './ApiService';

const API_URLS = window.AppConfig.API_URLS;

export default class StatesService {

    /**
     * This functions are used for States related tasks.
     * @return {}
     */
    static async create(requestBody) {
        return ApiService.PostData(API_URLS.STATES, requestBody, 'default');
    }

    static async getAllStateByTenant(id) {
        return ApiService.GetData(`${API_URLS.STATES}/${id}`, 'default', true);
    }

    static async edit(requestBody) {
        return ApiService.PutData(`${API_URLS.STATES}`, requestBody, 'default');
    }

    static async delete(id) {
        return ApiService.DeleteData(`${API_URLS.STATES}/${id}`, 'default');
    }

    static async getCountries() {
        return ApiService.GetData(`${API_URLS.COUNTRY}`, 'default', true);
    }

    static async getStateById(id) {
        return ApiService.GetData(`${API_URLS.STATES_BY_ID}/${id}`, 'default', true);
    }

}
